import { connect } from 'react-redux';

import { DeleteRemindersModal } from './DeleteRemindersModal';
import type { Dispatch } from 'redux';

import type { UUID, Vehicle } from '@cobliteam/common-types';

import type { WebData } from '@cobliteam/api-lib';

import type { MaintenanceState } from '../../store/maintenanceStore';
import { deleteRemindersRequest } from '../../store/UpcomingMaintenances/actionCreators';
import { selectVehiclesWithReminder } from '../../store/UpcomingMaintenances/selectors';

interface OwnProps {
  vehiclesWebData: WebData<Vehicle[]>;
  onClose: () => void;
}

interface StateProps {
  vehiclesWithRemindersWebData: WebData<Vehicle[]>;
}

interface DispatchProps {
  onConfirm: (vehicleIds: UUID[]) => void;
}

const mapStateToProps = (state: MaintenanceState, ownProps: OwnProps): StateProps => ({
  vehiclesWithRemindersWebData: selectVehiclesWithReminder(ownProps.vehiclesWebData)(state),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
  onConfirm: (vehicleIds) => {
    dispatch(deleteRemindersRequest(vehicleIds));
    ownProps.onClose();
  },
});

export const DeleteRemindersModalContainer = connect<StateProps, DispatchProps, OwnProps, MaintenanceState>(mapStateToProps, mapDispatchToProps)(DeleteRemindersModal);
